import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Accordion, AccordionItem, Card, CardBody ,Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  getKeyValue,} from "@heroui/react";
import { faChartColumn, faTable } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactApexChart from "react-apexcharts";


import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx";
import { apiRoute, GetLoginCredentialDb } from "../../constants/enum.js";
import LoadingCard from "../../components/LoadingCard.jsx";
import { getMonthNamesBetween } from "../../Utility/utility.js";


const labels = [
  {
    month: "Apr",
    id: 4,
  },
  {
    month: "May",
    id: 5,
  },
  {
    month: "Jun",
    id: 6,
  },
  {
    month: "Jul",
    id: 7,
  },
  {
    month: "Aug",
    id: 8,
  },
  {
    month: "Sep",
    id: 9,
  },
  {
    month: "Oct",
    id: 10,
  },
  {
    month: "Nov",
    id: 11,
  },
  {
    month: "Dec",
    id: 12,
  },
  {
    month: "Jan",
    id: 1,
  },
  {
    month: "Feb",
    id: 2,
  },
  {
    month: "Mar",
    id: 3,
  },
];

// const options = {
//   maintainAspectRatio: false,
//   reponsive: true,
//   plugins: {
//     legend: {
//       position: "top",
//     },
//     title: {
//       display: true,
//       text: "",
//     },
//   },
// }


const DashboardChart = ({ propDate }) => {
  const { compCode, yearId } = useSelector((state) => state.company);
  const { user } = useSelector((state) => state.auth)
  const [sale, setSale] = useState([])
  const [purchase, setPurchase] = useState([])
  const [chartXAxis, setChartXAxis] = useState([])
const columns = [
  {
    key: "year",
    label: "Year",
  },
  {
    key: "Mnth",
    label: "Month",
  },
  {
    key: "Total_Value",
    label: "Total Value",
    width: 120,
    align: "right",
  },
];

const apexChartOptions = {
  chart: {
    type: "bar",
    //height: 350,
    stacked: false,
    width: "100%",
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "80%",
      dataLabels: {
        position: "top",
      },
    },
  },
  xaxis: {
    categories: chartXAxis
  },
  yaxis: {
    tickAmount: 6, // Number of ticks

    labels: {
      formatter: function (value) {
        return value && value.toFixed(0) ? value.toFixed(0) : "";
      },
    },
  },
  fill: {
    opacity: 1,
  },
  colors: ["#F9C80E", "#5653FE"],
  // Set different colors for each group
  dataLabels: {
    offsetY: -20,
    // enabled: true,
    style: {
      colors: ["#3b3b3b"],
      // Set the font color to black
      fontSize: "10px",
    },
    formatter: function (value, { dataPointIndex, w }) {
      /* only show datalabels to very less values */
      /* values which are less than half of second y axis label */
      let secondYaxisLabel = w.globals.yAxisScale[0].result[1];
      if (value && value > 0 && value < secondYaxisLabel / 2) {
        return value && value.toFixed(0) ? value.toFixed(0) : "";
      } else {
        return "";
      }
    },
  },
  stroke: {
    show: false,
    width: 2,
    colors: ["#fff"],
  },
};

const SimpleTable = ({ rows, columns, id }) => {
 
  let index = 0;
  return (
    <Table aria-label="Example table with dynamic content" shadow="none">
      <TableHeader columns={columns}>
        {(column) => (
          <TableColumn
            className={`${column?.hasOwnProperty("align") ? "text-right" : ""}`}
            key={column.key}
          >
            {column.label}
          </TableColumn>
        )}
      </TableHeader>
      <TableBody items={rows}>
        {(item) => {
          index = index + 1;
          return (
            <TableRow key={item[id] || index}>
              {(columnKey) => {
                let column = columns.find((item) => item.key === columnKey);
                return (
                  <TableCell
                    className={`${column?.hasOwnProperty("align") ? "text-right" : ""
                      }`}
                  >
                    {getKeyValue(item, columnKey)}
                  </TableCell>
                );
              }}
            </TableRow>
          );
        }}
      </TableBody>
    </Table>
  );
};

  const { isLoading, data: purData = [], mutate: funLoadPurData } = usePost({
    url: apiRoute.dashboard.getTradingData,
    queryKey: "PurchaseChart",
    onSuccessTasks: (data) => {
      setPurchase(data)
    }

  });

  const { data: saleData = [], mutate: funLoadSaleData } = usePost({
    url: apiRoute.dashboard.getTradingData,
    queryKey: "SaleChart",
    onSuccessTasks: (data) => {
      setSale(data)

    }

  });

  useEffect(() => {
    const monthList=getMonthNamesBetween(propDate.start,propDate.end)
    setChartXAxis(monthList ||[])
    funLoadPurData({
      data: {
        compcode: compCode.join(","),
        fromdate: propDate.start,
        todate: propDate.end,
        //db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
        action: "Purchase",

      }
    })
    funLoadSaleData({
      data: {
        compcode: compCode.join(","),
        fromdate: propDate.start,
        todate: propDate.end,
        //db_inilchar: yearId ? yearId.substring(0, yearId.length - 4) : 'ACC',
        action: "Sale",
      }
    })
  }, [propDate])
  let saleChart = useMemo(() => {
    return labels.map((label) => {
      let saleMonth = sale
        ? sale.filter((item) => item.Month === label.id)
        : [];
      if (saleMonth.length > 0) {
        return saleMonth[0].Total_Value;
      } else {
        return 0;
      }
    });
  }, [sale]);

  let purchaseChart = useMemo(() => {
    return labels.map((label) => {
      let saleMonth = purchase
        ? purchase.filter((item) => item.Month === label.id)
        : [];
      if (saleMonth.length > 0) {
        return saleMonth[0].Total_Value;
      } else {
        return 0;
      }
    });
  }, [purchase]);
  //console.log(purchaseChart,"p")
  const apexChartSeries = [
    {
      name: "Amount of Purchase",
      data: purchaseChart,
    },
    {
      name: "Amount of Sale",
      data: saleChart,
    },
  ];

  if (isLoading) {
    <LoadingCard />
  }
  return (
    <>
      {/* <Card shadow="sm" radius="sm" className="mb-3 h-full bg-gray-100">
        <CardBody className="p-2">
          <MyComponent />
        
      <div className="flex flex-wrap w-full item-center justify-evenly mt-5" >
        <div className="border w-5/12 bg-white  ">

          <ReactApexChart
            options={apexChartOptions}
            series={apexChartSeries}
            width="90%"
            height="90%"
            type="bar"
          />

        </div> */}


      <Accordion variant="splitted" defaultExpandedKeys={["1"]}>
        <AccordionItem
          key="1"
          aria-label="Accordion 1"
          title="Sale"
          startContent={<FontAwesomeIcon icon={faChartColumn} />}
        >
          <div className="h-[70vh]">
            <ReactApexChart
              options={apexChartOptions}
              series={apexChartSeries}
              width="90%"
              height="90%"
              type="bar"
             
            />
          </div>
        </AccordionItem>
        {/* <AccordionItem
          key="2"
          aria-label="Accordion 2"
          title="Trading"
          className="px-0"
          startContent={<FontAwesomeIcon icon={faTable} />}
        >
          <Accordion variant="splitted">
            <AccordionItem key="1" aria-label="Accordion 1" title="Purchase">
              <SimpleTable rows={purchase} columns={columns} id="Month" />
            </AccordionItem>
            <AccordionItem key="2" aria-label="Accordion 2" title="Sale">
              <SimpleTable rows={sale} columns={columns} id="Month" />
            </AccordionItem>
          </Accordion>
        </AccordionItem> */}
      </Accordion>
      {/* </div>
      </CardBody>
      </Card> */}
    </>
  );
};

export default DashboardChart;
